import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import {
  getVentureSectorsPaginated,
  IVentureSectorsPaginatedResponse,
} from "api";
import { Nullable } from "config";
import { RootState } from "store/store";

import { IVentureSectorModalData } from "./types";
import { VentureSectorModalModes } from "./enums";

const initialState = {
  sectorsData: null as Nullable<IVentureSectorsPaginatedResponse["edges"]>,
  totalCount: 1,
  loading: false,
  modalData: {
    open: false,
    mode: VentureSectorModalModes.VIEW,
  } as IVentureSectorModalData,
};

const ventureSectorName = "venture-sector";

export const fetchVentureSectors = createAsyncThunk(
  `${ventureSectorName}/fetchVentureSectors`,
  async (_, { getState }) => {
    const filters = (getState() as RootState).FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }

    const response = await getVentureSectorsPaginated(filters);
    return response;
  }
);

const ventureSectorSlice = createSlice({
  name: ventureSectorName,
  initialState,
  reducers: {
    setVentureSectorModalData: (
      state,
      action: PayloadAction<IVentureSectorModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeVentureSectorModal: (state) => {
      state.modalData = initialState.modalData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchVentureSectors.fulfilled, (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          loading: false,
        };
      }
      return {
        ...state,
        sectorsData: action.payload?.edges,
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchVentureSectors.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const { setVentureSectorModalData, closeVentureSectorModal } =
  ventureSectorSlice.actions;

export default ventureSectorSlice.reducer;
